import { Api } from '@monorepo/shared/apiClient';
import { useEffect } from 'react';
import { useQuery } from 'react-query';

const KEY = 'svg-sprite';

function useFetchSvgSprite() {
  return useQuery<string>(KEY, Api.svgSprite);
}

/**
 * Fetches the SVG sprite and injects it into the DOM so old-web components
 * can render svgs via the sprite (<use /> syntax). Only load it where it's
 * needed. Returns the fetch query state.
 */
export function useSvgSprite() {
  const { data: svgSprite, ...queryInfo } = useFetchSvgSprite();

  useEffect(() => {
    if (!svgSprite) return undefined;

    const container = document.createElement('div');
    container.hidden = true;
    container.innerHTML = svgSprite;
    document.body.appendChild(container);

    return () => {
      document.body.removeChild(container);
    };
  }, [svgSprite]);

  return queryInfo;
}
